import React from 'react';
import { useAuth } from '../context';
import { TokenUsageDashboard } from '../components/token';

const TokenUsagePage = () => {
  const { user } = useAuth();
  
  return (
    <div className="page-background">
      <TokenUsageDashboard isAdmin={user?.isAdmin || false} />
    </div>
  );
};

export default TokenUsagePage;